var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9578 16.4066C13.9578 16.6842 14.068 16.9503 14.2643 17.1466C14.4605 17.3429 14.7267 17.4531 15.0043 17.4531C15.2818 17.4531 15.548 17.3429 15.7443 17.1466C15.9405 16.9503 16.0508 16.6842 16.0508 16.4066V8.03452C16.0508 7.75697 15.9405 7.49078 15.7443 7.29453C15.548 7.09827 15.2818 6.98801 15.0043 6.98801C14.7267 6.98801 14.4605 7.09827 14.2643 7.29453C14.068 7.49078 13.9578 7.75697 13.9578 8.03452L13.9578 16.4066Z",
    fill: "#FF3636"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 30C23.2842 30 30 23.2842 30 15C30 6.71582 23.2842 1.07288e-06 15 1.07288e-06C6.71582 1.07288e-06 1.07288e-06 6.71582 1.07288e-06 15C1.07288e-06 23.2842 6.71582 30 15 30ZM27.907 15C27.907 18.4231 26.5471 21.7061 24.1266 24.1266C21.7061 26.5471 18.4231 27.907 15 27.907C11.5769 27.907 8.29392 26.5471 5.87339 24.1266C3.45286 21.7061 2.09302 18.4231 2.09302 15C2.09302 11.5769 3.45286 8.29392 5.87339 5.87339C8.29392 3.45286 11.5769 2.09302 15 2.09302C18.4231 2.09302 21.7061 3.45286 24.1266 5.87339C26.5471 8.29392 27.907 11.5769 27.907 15Z",
    fill: "#FF3636"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6097 20.5988C13.6097 20.2287 13.7567 19.8738 14.0184 19.6121C14.2801 19.3505 14.635 19.2034 15.005 19.2034C15.3751 19.2034 15.73 19.3505 15.9917 19.6121C16.2534 19.8738 16.4004 20.2287 16.4004 20.5988C16.4004 20.9689 16.2534 21.3238 15.9917 21.5855C15.73 21.8471 15.3751 21.9941 15.005 21.9941C14.635 21.9941 14.2801 21.8471 14.0184 21.5855C13.7567 21.3238 13.6097 20.9689 13.6097 20.5988Z",
    fill: "#FF3636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSvg);
export default __webpack_public_path__ + "static/media/error-svg.4131ff72ec38ff7d93f169d0d37e0668.svg";
export { ForwardRef as ReactComponent };